import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class SpotlightCypressAttribute extends CypressAttribute {
  static buttons = {
    IMPERSONATE: 'SpotlightCypressAttribute:buttons:IMPERSONATE',
    ESTATE_ASSIGNED_TO_ME: 'SpotlightCypressAttribute:buttons:ESTATE_ASSIGNED_TO_ME'
  };

  static inputs = {
    SEARCH: 'SpotlightCypressAttribute:views:SEARCH'
  };

  static views = {
    GROUP_ITEM: 'SpotlightCypressAttribute:views:GROUP_ITEM',
    SEARCH_MODAL: 'SpotlightCypressAttribute:views:SEARCH_MODAL',
    SPOTLIGHT_GROUP_TITLE: 'SpotlightCypressAttribute:views:SPOTLIGHT_GROUP_TITLE',
    DOCUMENT_UPLOADED_BY_USER: 'SpotlightCypressAttribute:views:DOCUMENT_UPLOADED_BY_USER'
  };
}
